"use client"

import { type ReactNode, useState } from "react"
import { Box } from "@mui/material"
import { Outlet } from "react-router-dom"
import AdminSidebar from "../specific/AdminSidebar/AdminSidebar"

interface AdminLayoutProps {
    children?: ReactNode
}

export default function AdminLayout({ children }: AdminLayoutProps) {
    const [sidebarOpen, setSidebarOpen] = useState(true)
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

    const handleSidebarToggle = () => {
        setSidebarOpen(!sidebarOpen)
    }

    const handleCollapsedChange = (collapsed: boolean) => {
        setSidebarCollapsed(collapsed)
    }

    return (
        <Box sx={{ display: "flex", height: "calc(100vh - 64px)", position: "relative" }}>
            <AdminSidebar open={sidebarOpen} onToggle={handleSidebarToggle} onCollapsedChange={handleCollapsedChange} />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    overflow: "auto",
                    position: "absolute",
                    left: sidebarCollapsed ? "80px" : "280px",
                    right: 0,
                    top: 0,
                    bottom: 0,
                    transition: "left 0.3s ease",
                }}
            >
                {children || <Outlet />}
            </Box>
        </Box>
    )
}

